import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'suggestions',
  templateUrl: './suggestions.component.html',
  styleUrls: ['./suggestions.component.scss']
})
export class SuggestionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
